import {ClientIds} from './clients';
import {RouteNames} from './routes';

export const legalDocuments = [
  {slug: RouteNames.dataProtectionPolicy, displayName: 'footer.dataProtectionPolicy'},
  {slug: RouteNames.terms, displayName: 'footer.terms'},
];

/**
 * Clients whose legal documents are static PDFs served from the repo instead of
 * coming from Wicket. Keyed by client id, then by the normalized document type
 * (the route slug with `-` replaced by `_`, see ViewLegalDocumentComponent).
 */
export const clientLegalDocuments: Record<string, Record<string, string>> = {
  [ClientIds.cement]: {
    privacy_policy: '/assets/documents/privacy_policy.pdf',
    terms: '/assets/documents/terms.pdf',
  },
  [ClientIds.fightingSpirit]: {
    privacy_policy: '/assets/documents/fighting-spirit/privacy_policy.pdf',
    terms: '/assets/documents/fighting-spirit/terms.pdf',
    information_obligation:
      '/assets/documents/fighting-spirit/information_obligation.pdf',
  },
};
